<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title37"></a>
<div class="p-c-br"><span>For David,<br/> who did the math,<br/> and Holly,<br/> who keeps me grounded</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429977456_ded01.vue?5c4e016c